/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/
import { Component, ComponentFactoryResolver, ComponentRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ReviewBaseComponent } from './review-base.component';
import { StringVariableService } from '@workflow/service/string-variable/string-variable.service';
/**
 * The component responsible to resolve and render the building block
 */

export const reviewPageRegistry = {};
// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function ReviewComponent(controlType: string) {
  return (target) => {
    const key = controlType;
    if (!reviewPageRegistry[key]) {
      reviewPageRegistry[key] = target;
    }
  };
}

@Component({
  selector: 'cu-review-resolver',
  template: `<ng-container #pageContainer></ng-container>`
})
export class ReviewResolverComponent extends ReviewBaseComponent implements OnInit {
  @Input()
  public reviewComponentType: string;

  /**
   * Reference to  controlContainer where building block is rendered
   */
  @ViewChild('pageContainer', { static: true, read: ViewContainerRef })
  public pageContainer: ViewContainerRef;

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    public readonly stringVariableService: StringVariableService,
    private readonly router: Router
  ) {
    super(stringVariableService);
  }

  public ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    const component = this.resolve<ReviewBaseComponent>(this.reviewComponentType).instance;
    component.page = this.page;
    component.card = this.card;
    component.flow = this.flow;
    component.editUrlFn = this.editUrlFn;
  }

  public resolve<T>(type: string): ComponentRef<T> {
    const pageInstance = reviewPageRegistry[type];
    if (!pageInstance) {
      throw new Error(`No Component has been registered for type '${type}'. `);
    }

    const factory = this.componentFactoryResolver.resolveComponentFactory(pageInstance);
    return this.pageContainer.createComponent(factory) as ComponentRef<T>;
  }
}
